<template>
  <div>
    <label class="my-1 flex cursor-pointer items-center">
      <input
        type="checkbox"
        value="1"
        class="relative h-[18px] w-[18px] cursor-pointer"
        :class="[
          error ? 'border-error text-error' : 'border-primary',
          checkboxPosition,
          inputStyles,
        ]"
        :name="name"
        :checked="checked"
        :disabled="disabled"
        @change="$emit('change', $event.target.checked)"
      />

      <span v-if="!label" class="ml-2 leading-none">
        <span v-if="required" class="text-error">*</span
        ><span v-if="!isExpanded"><slot></slot></span>
        <span v-if="isExpanded">
          <slot name="expandLabel"></slot>
        </span>
        <div v-if="isExpandable" class="inline w-full">
          <button
            type="button"
            class="ml-1 underline"
            @click="isExpanded = !isExpanded"
          >
            {{ isExpanded ? $t('action.collapse') : $t('action.expand') }}
          </button>
        </div>
      </span>

      <span v-else class="ml-2 leading-none" :class="{ 'text-error': hasError }"
        ><span v-if="required" class="text-error">*</span>{{ label
        }}<span v-if="required && !expandLabel">*</span>
        <span v-if="isExpanded">{{ expandLabel }}</span>
        <div v-if="expandLabel" class="w-full text-right">
          <button
            type="button"
            class="ml-1 underline"
            @click="isExpanded = !isExpanded"
          >
            {{ isExpanded ? $t('action.collapse') : $t('action.expand') }}
          </button>
        </div>
      </span>
    </label>

    <BaseErrorMessage v-if="hasError">
      {{ $t(errorMsg) }}
    </BaseErrorMessage>
  </div>
</template>

<script setup>
defineEmits(['change'])
const props = defineProps({
  checkboxPosition: {
    type: [String],
    default: 'self-start',
  },
  checked: {
    type: [Boolean],
    required: true,
  },
  disabled: {
    type: [Boolean],
    default: false,
  },
  id: {
    type: [String],
    required: true,
  },
  name: {
    type: [String],
    default: '',
  },
  label: {
    type: [String],
    default: '',
  },
  expandLabel: {
    type: [String],
    default: null,
  },
  isExpandable: {
    type: Boolean,
    default: false,
  },
  required: {
    type: Boolean,
    default: false,
  },
  error: {
    type: [Boolean],
    default: false,
  },
  errors: {
    type: [Object],
    default: null,
  },
  anyDirty: {
    type: [Boolean],
    default: true,
  },
  theme: {
    type: [String],
    default: 'rounded',
  },
})

const isExpanded = ref(false)

const hasError = computed(() => {
  return props.anyDirty && props.errors && props.errors?.[props.name]
})

const errorMsg = computed(() => {
  return props.errors[props.name] instanceof Array
    ? props.errors[props.name][0]
    : props.errors[props.name]
})

const inputStyles = computed(() => {
  return props.theme === 'rounded' ? 'rounded-full' : 'rounded border-primary'
})
</script>
